import React from 'react'
import { Box, Typography, Stack, Grid, InputLabel, TextareaAutosize, Select, MenuItem, FormHelperText, Checkbox, Button } from '@mui/material'
import { Link, Route, Routes } from 'react-router'

import SendIcon from '@mui/icons-material/Send';
import { ArrowForward } from '@mui/icons-material';
import FlowChart from './FlowChart';
import Navbar from '../Auth/Navbar';
import { NavLink, useNavigate } from 'react-router-dom';

function FormTerms() {
        const navigate = useNavigate();
    
    const btnBack = {
        backgroundColor: "#15513c",
        width: "180px",
        borderReduis: "6px",
        color: "#fff",
        p: "16px",
        m: "10px 0"

    }
    return (
        <>
          <Navbar />
            <Stack sx={{ backgroundColor: "#eee", textAlign: "center", minHeight: "90vh", borderRadius: "6px" }} alignItems={"center"} justifyContent={"center"}>
                <Stack sx={{ backgroundColor: "#FFF", minHeight: "80vh", borderRadius: "6px", width: "85%", m: 4, p: 4 }}>
                    <Grid container justifyContent={"space-between"}>
                        <Grid item xs={2} >
                            <FlowChart index={5} />
                        </Grid>
                        <Grid item xs={8} sx={{ width: "80%" }} alignItems={"end"} justifyContent={"flex-end"}>
                            <Stack>
                                <Typography variant='h5' sx={{ fontWeight: "bold", p: 1, textAlign: "right", display: 'flex', flexDirection: "row-reverse" }} >
                                    <span>-5</span>
                                    طريقة التواصل والشروط والأحكام
                                </Typography>
                                <form>
                                    <Grid container spacing={2} justifyContent={"end"}>
                                        <Grid item xs={5} >
                                            <Box mt={2}>
                                                <InputLabel>طريقة التواصل المفضلة</InputLabel>
                                                <Select label="البلد" fullWidth displayEmpty>
                                                    <MenuItem value=""><em>سوريا</em></MenuItem>
                                                    {/* Add dynamic options here */}
                                                </Select>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={5} >
                                            <Box mt={2}>
                                                <InputLabel>طريقة التواصل البديلة(إن وجدت)</InputLabel>
                                                <Select label="البلد" fullWidth displayEmpty>
                                                    <MenuItem value=""><em>سوريا</em></MenuItem>
                                                    {/* Add dynamic options here */}
                                                </Select>
                                            </Box>

                                        </Grid>

                                    </Grid>
                                    <Box sx={{ display: "flex", justifyContent: "end", alignItems: 'center' }}>
                                        <Typography variant='body1' sx={{ color: 'black' }}>
                                            <span>قرأت </span>
                                            <Link to="/terms" style={{ color: "#15513c" }}>الشروط والأحكام </Link>
                                            <span>وأوافق عليها</span>
                                        </Typography>
                                        <Checkbox defaultChecked color="success" />
                                    </Box>
                                </form>
                            </Stack>
                        </Grid>

                        <Stack direction={"row"} justifyContent={"end"} alignItems={"center"} sx={{ width: "100%", gap: 2, my: 4 }}>
                            <Button sx={btnBack}  onClick={() => navigate("/")} >
                                <SendIcon sx={{ transform: "rotate(-45deg)" }} />إرسال
                            </Button>
                            <Link to="/InputDocuments" className='LinkbtnBack'>
                                رجوع
                                <ArrowForward sx={{ mt: 1 }} />
                            </Link>
                        </Stack>
                    </Grid>
                </Stack >
            </Stack >
        </>
    )
}


export default FormTerms